export default __webpack_public_path__ + "static/media/icon-arrow-right.357b9db8.svg";